<layout-wrapper class="page-title hide-on-mobile static-content" *ngIf="{mainParticipantUser: mainParticipantUser$ | async } as headerCtx">
  <div class="desktop-header">
    <app-button
      icon="arr-left"
      (click)="back()"
    ></app-button>
    <app-user-avatar
        [user]="headerCtx.mainParticipantUser"
        style="cursor: pointer;"
        [size]="32">
    </app-user-avatar>
    <span 
      class="title" 
      style="cursor: pointer;"
      [routerLink]="'/user-profile/user/' + headerCtx?.mainParticipantUser?.id"
    >Chat with {{headerCtx?.mainParticipantUser?.userName}}</span>
  </div>
</layout-wrapper>
<div class="row g-0 content-padding"></div>


<div class="chat-message-list" #messagesContainer (wheel)="onWheel($event)">
  <layout-wrapper>
    <div class="chat-message-list-inverted-scroll" *ngIf="{
          allUsersMap: usersService.entityMap$ | async,
          currentUser: appStateService.currentUser$ | async,
          messages: messages$ | async,
          conversation: conversation$ | async
      } as messagesListCtx">
      <ng-container *ngFor="let message of messagesListCtx.messages; trackBy: trackByFn">
        <ng-container *ngIf="{isMessageMine: isMessageMine(message)} as messageCtx">
          <app-chat-divider 
            *ngIf="messagesListCtx.conversation.lastReadMessageIndex === (message.index - 1) && !messageCtx.isMessageMine" 
            label="Unread"
          ></app-chat-divider>
          <app-message-item
            class="chat-message-list-item"
            [message]="message"
            [isMessageMine]="messageCtx.isMessageMine"
            [intersectionObserver]="intersectionObserver"
            [lastUnreadIndex]="messagesListCtx.conversation.lastReadMessageIndex"
            [author]="messageCtx.isMessageMine
              ? messagesListCtx.currentUser
              : messagesListCtx.allUsersMap[message.author]">
          </app-message-item>
        </ng-container>
      </ng-container>
    </div>
  </layout-wrapper>
</div>

<div class="message-input">
  <layout-wrapper>
    <app-message-input
      *ngIf="canSendMessages$ | async; else blockedByUser"
      [formGroup]="messageFormGroup"
      fieldName="text"
      placeholder="Message..."
      (onSend)="onFormSubmit()"
      [showError]="false"
    ></app-message-input>
  </layout-wrapper>
</div>

<ng-template #blockedByUser>
  <span class="placeholder">You can’t send messages because this user has blocked you</span>
</ng-template>